// Module
var code = "<p>This section provides the ability to set image data.</p> <p>The data can be input manually, or chosen from loaded data.</p> <p>Each data item is identified by its <code>id</code> in the SVG.</p> ";
// Exports
module.exports = code;